import { watch } from 'vue'
import { useQuery, useMutation } from '@tanstack/vue-query'
import { $axios, $queryClient } from '@/boot/initApi'

const QUERY_KEY = ['passkeys']

export default ({ passkeys }) => ({
  indexPasskeys: ({ enabled = true } = {}) => {
    const query = useQuery({
      queryKey: QUERY_KEY,
      queryFn: async () => {
        const { data } = await $axios.get('/api/passkeys')
        return data?.passkeys ?? []
      },
      enabled,
      staleTime: 1000 * 60
    }, $queryClient)

    watch(query.data, val => {
      if (val) passkeys.value = val
    }, { immediate: true })

    return query
  },

  destroyPasskey: () => useMutation({
    mutationFn: id => $axios.delete(`/api/passkeys/${id}`),
    onSuccess: () => $queryClient.invalidateQueries({ queryKey: QUERY_KEY })
  }, $queryClient)
})
